import React, { createContext, useContext, useState } from 'react';
import { LoadScript } from '@react-google-maps/api';

const GoogleMapsContext = createContext();

const GOOGLE_MAPS_LIBRARIES = ['geometry'];
const GOOGLE_MAPS_API_KEY = "AIzaSyBavWMdCg2IpMy-dkMrsMqfHjmCNt5xDOI";

export const GoogleMapsProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);

  const handleLoad = () => {
    console.log('Google Maps API loaded successfully');
    setIsLoaded(true);
    setLoadError(null);
  };

  const handleError = (error) => {
    console.error('Google Maps API failed to load:', error);
    setLoadError(error);
    setIsLoaded(false);
  };

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      <LoadScript
        googleMapsApiKey={GOOGLE_MAPS_API_KEY}
        libraries={GOOGLE_MAPS_LIBRARIES}
        preventGoogleFontsLoading={true}
        onLoad={handleLoad}
        onError={handleError}
        loadingElement={
          <div className="google-maps-global-loading">
            <div style={{ 
              position: 'fixed', 
              top: 0, 
              left: 0, 
              right: 0, 
              bottom: 0, 
              backgroundColor: 'rgba(255,255,255,0.9)', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              zIndex: 9999
            }}>
              <div style={{ textAlign: 'center' }}>
                <div className="loading-spinner"></div>
                <h3>Loading Google Maps...</h3>
                <p>Initializing mapping services</p>
              </div>
            </div>
          </div>
        }
      >
        {children}
      </LoadScript>
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (context === undefined) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return context;
};